import { render, staticRenderFns } from "./VueStock.vue?vue&type=template&id=813eb8e6&"
import script from "./VueStock.vue?vue&type=script&lang=js&"
export * from "./VueStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports